import ThemedText from '@portal/components/ThemedText/ThemedText';
import { translate } from '@portal/services/i18n';
import React, { useEffect, useState } from 'react';
import AdvancedButton from '../AdvancedButton/AdvancedButton';
import './AdvancedBanners.less';

export interface AdvancedBannersProps {
  banners: models.Banner[];
  limitVisible?: number;
  testId: string;
  autoPlay?: boolean;
  autoPlayInterval?: number;
}

const AdvancedBanners = ({
  banners,
  autoPlay = true,
  autoPlayInterval = 6000,
}: AdvancedBannersProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    if (!autoPlay || banners.length <= 1) return;
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % banners.length);
    }, autoPlayInterval);
    return () => clearInterval(timer);
  }, [banners.length, autoPlay, autoPlayInterval]);

  const handleDotClick = (index: number) => setCurrentIndex(index);

  const handleBannerClick = (banner: models.Banner) => {
    if (banner.link) window.open(banner.link, '_blank');
  };

  if (banners.length === 0) return null;

  const currentBanner = banners[currentIndex];

  return (
    <div className="advanced-banners">
      <div
        className="advanced-banners__slider"
        onClick={() => handleBannerClick(currentBanner)}
      >
        <div className="advanced-banners__slider__track">
          <div
            className="advanced-banners__slider__slide"
            style={{
              backgroundImage: `url("${currentBanner.url}")`,
              imageRendering: 'crisp-edges',
            }}
          >
            <div className="advanced-banners__slider__content">
              <ThemedText
                variant="h2"
                className="advanced-banners__slider__content__title"
              >
                {currentBanner.title}
              </ThemedText>
              <ThemedText
                variant="body"
                className="advanced-banners__slider__content__description"
              >
                {currentBanner.description}
              </ThemedText>
              {currentBanner.link ? (
                <AdvancedButton
                  variant="contained"
                  text={translate('COMPONENTS.ADVANCED_BANNERS.LEARN_MORE')}
                />
              ) : null}
            </div>
          </div>
        </div>
      </div>
      {banners.length > 1 && (
        <div className="advanced-banners__nav">
          {banners.map((_, index) => (
            <div
              key={index}
              className={`advanced-banners__dot ${
                index === currentIndex ? 'advanced-banners__dot--active' : ''
              }`}
              onClick={() => handleDotClick(index)}
            />
          ))}
        </div>
      )}
    </div>
  );
};

export default AdvancedBanners;
